function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { FieldBase } from "./FieldBase";
import PropTypes from "prop-types";
import React from "react";
import "./TextAreaField.css"; // #region HOOK

/**
 * Représente un champ de saisie multi-ligne
 * @class
 * @category Fields
 * @param {Fields.TextAreaField.propTypes} props Les propriétés du composant
 */

function TextAreaField(props) {
  // Récupération des props
  var backgroundColor = props.backgroundColor,
      name = props.name,
      obligatory = props.obligatory,
      onKeyPress = props.onKeyPress,
      placeholder = props.placeholder,
      readonly = props.readonly,
      rows = props.rows,
      textareaRef = props.textareaRef,
      textColor = props.textColor,
      tooltip = props.tooltip,
      value = props.value;
  return /*#__PURE__*/React.createElement(FieldBase, _extends({}, props, {
    iconOnTop: true,
    render: function render(handleChange) {
      return /*#__PURE__*/React.createElement("textarea", {
        ref: textareaRef,
        name: name,
        className: "TextAreaField",
        placeholder: placeholder ? placeholder : tooltip,
        rows: rows,
        style: {
          backgroundColor: backgroundColor,
          color: textColor,
          width: "100%"
        },
        value: value ? value : "",
        onChange: handleChange,
        onKeyPress: onKeyPress,
        readOnly: readonly,
        required: obligatory
      });
    }
  }));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link TextAreaField}
 * @typedef {Object} TextAreaField.propTypes
 * @property {string} name Le nom du champ
 * @property {string} tooltip Le descriptif du champ
 * @property {function} onChange La fonction de callback de l'évènement onChange
 * @property {string} [backgroundColor=#fff] La couleur de fond
 * @property {string} [textColor=#000] La couleur du texte
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [icon=null] L'icône à afficher
 * @property {boolean} [iconOnTop=false]
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {function} [onClickIcon=null] La fonction de callback de l'évènement onClick de l'icône
 * @property {function} [onMouseEnterIcon=null] La fonction de callback de l'évènement onMouseEnterIcon
 * @property {boolean} [obligatory=false] true si le champ est obligatoire
 * @property {boolean} [readonly=false] true si le champ est désactivé
 * @property {boolean} [alert=false] true si l'on veut afficher une icône d'alerte
 * @property {boolean} [msgAlert=""] Message d'alerte à afficher quand alert vaut true
 * @property {string} [rows=15] Le nombre de lignes du composant
 * @property {string} [value=""] Le contenu du composant
 * @property {string} [onKeyPress=null] La fonction de callback de l'évènement onKeyPress
 * @property {string} [placeholder=null] Par défaut le placeholder vaut _tooltip_, mais on peut le surcharger grâce à cette propriété
 * @property {function} [textareaRef=null] La fonction de rappel de référence du champ <input>
 */


TextAreaField.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  width: PropTypes.string,
  icon: PropTypes.string,
  iconOnTop: PropTypes.bool,
  keepSpaceIcon: PropTypes.bool,
  onClickIcon: PropTypes.func,
  onMouseEnterIcon: PropTypes.func,
  obligatory: PropTypes.bool,
  readonly: PropTypes.bool,
  alert: PropTypes.bool,
  msgAlert: PropTypes.string,
  rows: PropTypes.number,
  value: PropTypes.string,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  textareaRef: PropTypes.func
} : {};
/*
  Valeurs par défaut des propriétés
*/

TextAreaField.defaultProps = {
  backgroundColor: "#fff",
  textColor: "#000",
  width: "100%",
  icon: null,
  iconOnTop: false,
  keepSpaceIcon: false,
  onClickIcon: null,
  onMouseEnterIcon: null,
  obligatory: false,
  readonly: false,
  alert: false,
  msgAlert: "",
  rows: 15,
  value: "",
  onKeyPress: null,
  placeholder: null,
  textareaRef: null
}; // #endregion

export { TextAreaField };